import VueTheMask from 'vue-the-mask'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCcVisa, faCcMastercard, faCcAmex, faCcJcb, faCcDiscover, faCcDinersClub } from '@fortawesome/free-brands-svg-icons'
import { faCreditCard, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import CreditCardPayment from './components/integrapayCardPayment.vue'
import CreditCardStorage from './components/integrapayCardStorage.vue'

const install = function(Vue, globalOptions) {
  console.log(`Integrapay Payments __buildVersion__ : Build date: __buildDate__`)

  library.add(faCreditCard, faCcVisa, faCcMastercard, faCcAmex, faCcJcb, faCcDiscover, faCcDinersClub, faTimes)

  // VeeValidate should already be installed globally, so we skip it here
  // Vue.use(VeeValidate, {
  //   errorBagName: 'errorBag',
  //   events: 'change|blur|input',
  //   mode: 'eager'
  // })

  Vue.use(VueTheMask)

  Vue.component('font-awesome-icon', FontAwesomeIcon)
  Vue.component('integrapay-card-storage', CreditCardStorage)
  Vue.component('integrapay-card-payment', CreditCardPayment)
}

// Create module definition for Vue.use()
const plugin = {
  install
}

// To auto-install on non-es builds, when vue is found
// eslint-disable-next-line no-redeclare
/* global window, global */
if (process.env.ES_BUILD === 'false') {
  let GlobalVue = null
  if (typeof window !== 'undefined') {
    GlobalVue = window.Vue
  }
  else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue
  }
  if (GlobalVue) {
    GlobalVue.use(plugin)
  }
}

export {
  CreditCardStorage,
  CreditCardPayment
}

export default {
  CreditCardStorage,
  CreditCardPayment,

  install
}
